const coordtransform = require('coordtransform');
// 百度坐标转国测局坐标
exports.bd09togcj02 = function (latLng) {
  return coordtransform.bd09togcj02(latLng[0], latLng[1]);
};
// 国测局坐标转百度坐标
exports.gcj02tobd09 = function (latLng) {
  return coordtransform.gcj02tobd09(latLng[0], latLng[1]);
};

// wgs84转国测局坐标
exports.wgs84togcj02 = function (latLng) {
  return coordtransform.wgs84togcj02(latLng[0], latLng[1]);
};
// 国测局坐标转wgs84坐标
exports.gcj02towgs84 = function (latLng) {
  return coordtransform.gcj02towgs84(latLng[0], latLng[1]);
};

// wgs84转百度坐标
exports.wgs84tobd09 = function (latLng) {
  const point = coordtransform.wgs84togcj02(latLng[0], latLng[1]); // wgs84=>gcj02
  return coordtransform.gcj02tobd09(point[0], point[1]);
};

// 百度坐标转wgs84坐标
exports.bd09towgs84 = function (latLng) {
  const point = coordtransform.bd09togcj02(latLng[0], latLng[1]);
  return coordtransform.gcj02towgs84(point[0], point[1]);
};



// WEBPACK FOOTER //
// ./src/service/coordUtil.js